const requests = {
  listRequests: {
    list: "List Events Requests",
    search: "Search by applicant name, event name",
    status: "Status",
    eventName: "Event Name",
    applicantID: 'Applicant ID',
    applicantName: "Applicant Name",
    note: "Note",
    shift: "Shift",
    date: "Date",
    nationality: "Nationality",
    rating: "Rating",
    all: "All",
    approved: "Accepted",
    pending: "Pending",
    cancelled: "Cancelled",
    auto_cancelled: "Auto Cancelled",
    hint: "To change the role before approving the request, edit the dropdown selection",
    placeholder: "No requests received yet!",
    warningMessage:
      "The maximum number for this specific gender has been completed, Are you sure you want to continue?",
    warningTitle: "Approval Warning",
    cityOfResidence: "City",
    speaking: "Speaking Proficiency",
    changeRoleTitle: "Change Role For ",
    areYouSure: "Are you sure you want to approve the selected requests?",
    approvedRequest: "Approve Requests",
    language: "Language",
    searchPlaceholder: "Search by applicant's name, applicant's id",
  },
};

export default requests;
